import React, { useState, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { ButtonHLPure, DialogWarningGL, DialogSystemGLPure } from '../../pures';
import "./signature-request-profile-document.css";
import { b64toBlob } from "./../../../validators";
import PdfReader from '../../pures/adobePfdReader/PdfReader';
import SiganturePackageRequestProfileView from "../signature-request-profile-data/signature-package-request-profile.view";
import { FormatTextUtil } from '../../../utils'

const SignatureRequestProfileDocumentView = (props) => {
  const { t } = useTranslation();
  const { step, onHandleBack, onHandleNext, signatureProfileSelected } = props;
  const { next, back } = step;
  const [blobUrl, setBlobUrl] = useState("");
  const [currentSystem, setCurrentSystem] = useState("");
  const [modalTermsCond, setModalTermsCond] = useState(null);
  const [selectedFileBase64, setSelectedFileBase64] = useState('')
  const [urlPdf, setUrlPdf] = useState('')
  const [acceptDocumentError, setAcceptDocumentError] = useState(false)
  const [modalWarningOpen, setModalWarningOpen] = useState(false)
  const [missingFields, setMissingFields] = useState([])
  const [errorCurrentNameSignature, setErrorCurrentNameSignature] = useState(false)
  const [openInvalidFileModal, setOpenInvalidFileModal] = useState(false)

  const pdf = useMemo(() => <PdfReader className="pdfReader" file={selectedFileBase64} isFile src={`data:application/pdf;base64,${selectedFileBase64}`} fileName={props.selectedFileName}  ></PdfReader>, [selectedFileBase64])
  const pdfContractnegotiation = useMemo(() => <PdfReader className="pdfReader" url={urlPdf} awsURL src={urlPdf}  ></PdfReader>, [urlPdf])

  useEffect(() => {
    setCurrentSystem(navigator.userAgent);
  }, []);

  let infodevice = currentSystem.toLowerCase();
  let isMobile = infodevice.includes("android");
  isMobile = isMobile || infodevice.includes("iphone");
  isMobile = isMobile || infodevice.includes("ipad");
  isMobile = isMobile || infodevice.includes("mobile");

  const titleDialog = t('signaturePackageRequestProfileView.modal.title.required')
  const widthDialog = isMobile ? 300 : 400
  const heightDialog = isMobile ? 295 : 27

  function isTouchScreendevice() {
    return "ontouchstart" in window || navigator.maxTouchPoints;
  }

  if (isTouchScreendevice()) {
    isMobile = true;
  }

  useEffect(() => {
    if (props.selectedFileBase64 && !props.isContractFromNegotiation) {
      const blob = b64toBlob(props.selectedFileBase64, "application/pdf");
      setBlobUrl(blob);
      setSelectedFileBase64(props.selectedFileBase64)
    }
  }, [props.selectedFileBase64]);

  useEffect(() => {
    if (props.contractFromNegotiation && props.contractFromNegotiation.url) {
      setUrlPdf(props.contractFromNegotiation.url)
    }
  }, [props.contractFromNegotiation])



  const onHandleSubmit = () => {
    if (props.nameSignature) {
      if (props.nameSignature && typeof props.onChangeNameSignature === 'function') {
        const syntheticEvent = { target: { value: props.nameSignature } }
        props.onChangeNameSignature(syntheticEvent)
      }
    }

    const hasInvalidFilename = validateFilenamesOnSubmit()
    if (hasInvalidFilename) {
      setOpenInvalidFileModal(true)
      return
    }

    const missing = validateRequiredFields()
    const hasNameSignature = props.nameSignature && props.nameSignature.trim() !== ""

    setErrorCurrentNameSignature(!hasNameSignature)

    if (!props.documentAccept) {
      setAcceptDocumentError(true)
    }

    if (missing.length > 0) {
      setMissingFields(missing)
      setModalWarningOpen(true)
      return
    }

    const isValid = props.onValidateProfileData()
    if (isValid) onHandleNext()
  }

  const validateFilenamesOnSubmit = () => {
    const invalidChars = /[!@#$%^&*()+={}[\]:;"'<>?,/\\|~]/
    const hasAccentExceptEnye = (base) => {
      const normalized = FormatTextUtil.normalizeTextExcludedÑ(base || '')
      return normalized !== (base || '')
    }

    const validateName = (name) => {
      if (!name) return false
      const base = name.replace(/\.[^/.]+$/, '')
      if (invalidChars.test(base)) return true
      if (hasAccentExceptEnye(base)) return true
      return false
    }

    if (props.profilesDocuments && props.profilesDocuments.length > 0) {
      const anyInvalid = props.profilesDocuments.some((doc) => {
        const name = doc?.document?.name || doc?.documentName
        return validateName(name)
      })
      return anyInvalid
    }

    const singleName = props.selectedFile?.name || props.selectedFileName
    return validateName(singleName)
  }

  const onChangeCheckboxHandler = (e) => {
    if (acceptDocumentError) setAcceptDocumentError(false)
    props.handleChangeCheckbox(e)
  }

  const validateRequiredFields = () => {
    const missing = []

    if (!props.nameSignature || props.nameSignature.trim() === '') {
      missing.push(t('signatureRequestProfileDocumentView.requestName'))
    }

    let hasDocument = false
    if (props.profilesDocuments && props.profilesDocuments.length > 0) {
      hasDocument = props.profilesDocuments.some(doc => doc.upload)
    } else if (props.selectedFileBase64) {
      hasDocument = true
    }

    if (!hasDocument) {
      missing.push(t('signatureRequestProfileDocumentView.uploadDocument'))
    }

    if (!props.documentAccept) {
      missing.push(t('signatureRequestProfileDocumentView.documentVerification'))
    }

    return missing
  }

  const onChangeNameSignature = (e) => {
    if (errorCurrentNameSignature) {
      setErrorCurrentNameSignature(false)
    }
    props.onChangeNameSignature(e)
  }

  const formatMissingFieldsMessage = (missingFields) => {
    if (missingFields.length === 0) return ''

    if (missingFields.length === 1) {
      return `${missingFields[0]}`
    }

    const allButLast = missingFields.slice(0, -1).join(', ')
    const last = missingFields[missingFields.length - 1]
    return `${allButLast}${t('signatureRequestProfileDocumentView.validation.text')} ${last}`
  }

  const messageWarning = `${t('signaturePackageRequestProfileView.modal.description.warning')} ${formatMissingFieldsMessage(missingFields)}. ${t('signaturePackageRequestProfileView.modal.validation.error')}`


  return (
    <div className={"step-card-SiganturePackageRequestProfileView"}>
      <SiganturePackageRequestProfileView
        {...props}
        acceptDocumentError={acceptDocumentError}
        handleChangeCheckbox={onChangeCheckboxHandler}
        open={modalWarningOpen}
        onClose={() => setModalWarningOpen(false)}
        missingFields={missingFields}
        errorCurrentNameSignature={errorCurrentNameSignature}
        onChangeNameSignature={onChangeNameSignature}
      />
      <DialogSystemGLPure
        isWarnign={modalWarningOpen}
        messageWarning={messageWarning}
        showBtnSubmitWarning={false}
        showBtnCancelWarning={true}
        handleWarningClose={() => setModalWarningOpen(false)}
        handleWarningSubmit={() => setModalWarningOpen(false)}
        labelWarningBtnCancel={t('button.close')}
        heightDialog={heightDialog}
        widthDialog={widthDialog}
        titleDialog={titleDialog}
      />

      <DialogSystemGLPure
        isWarnign={openInvalidFileModal}
        messageWarning={t('signaturePackageRequestProfileView.modal.description.invalid.file')}
        showBtnSubmitWarning={false}
        showBtnCancelWarning={true}
        handleWarningClose={() => setOpenInvalidFileModal(false)}
        handleWarningSubmit={() => setOpenInvalidFileModal(false)}
        labelWarningBtnCancel={t('button.close')}
        heightDialog={heightDialog}
        widthDialog={widthDialog}
        titleDialog={t('signaturePackageRequestProfileView.modal.title.invalid.file')}
      />

      <div className="action-buttons">
        <ButtonHLPure
          nameBtn={back}
          onClickBtn={onHandleBack}
        />
        <ButtonHLPure
          nameBtn={next}
          primary
          onClickBtn={onHandleSubmit}
        />
      </div>
    </div>
  );
};

export default SignatureRequestProfileDocumentView;
